export { PrivacyPolicy } from './privacy-policy';
